export const BASE_URL = 'https://travelin-server.herokuapp.com';
export const TRIPS_PATH = 'trips';

export const USERS_PATH = 'users';
export const LOGIN_PATH = 'login';
